export const getWaitlistSectionProps = (application) => {
  const {
    applicationStatus: currentApplicationStatus,
    property: { organizationId },
    propertyId,
    id: applicationId,
  } = application;
  return {
    organizationId,
    propertyId,
    applicationId,
    currentApplicationStatus,
  };
};

export const hasCompletedApplicationForm = ({
  applicants,
  formData,
  requireAllAdults,
}) => {
  const isFormComplete = (applicant) => formData?.[applicant.id]?.isComplete;

  if (!requireAllAdults) return applicants?.some(isFormComplete);

  const adults = (applicants ?? []).filter((applicant) =>
    Boolean(applicant.applicantCustomer),
  );

  return adults.length > 0 && adults.every(isFormComplete);
};
